export default __webpack_public_path__ + "static/media/tapicerowane8.cd51f244.jpg";